var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chroma-key-background__root",class:{ 'chroma-key-background__root--transparent': _vm.transparent }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }